module["exports"] = [
  "Hr.",
  "Fr.",
  "Dr.",
  "Prof. Dr."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/name/prefix.js
// module id = 983
// module chunks = 1